import { Link } from 'react-router-dom';
import { company } from '../data/company';
import { categories } from '../data/categories';
import { industries } from '../data/industries';
import { downloadFile } from '../utils/utils';
import Logo from './brand/Logo';
import Icon from './Icon';

const companyLinks = [
  { name: 'About Us', to: '/about' },
  { name: 'Product Finder', to: '/product-finder' },
  { name: 'Industries', to: '/industries' },
  { name: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-ink text-white/70">
      <div className="container-page py-16">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4 lg:grid-cols-5">
          <div className="col-span-2 lg:col-span-2">
            <Logo variant="light" />
            <p className="mt-5 max-w-sm text-sm leading-6 text-white/60">
              {company.legalName} — {company.since}. A trusted Indian manufacturer of petroleum
              sulphonates, metalworking fluids, textile additives and fuel dyes, based in
              Ankleshwar, Gujarat.
            </p>
            <button
              type="button"
              onClick={() => downloadFile(company.productGuide.fileUrl, company.productGuide.fileName)}
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              <Icon name="download" className="h-4 w-4" /> Product Guide (PDF)
            </button>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">Products</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/products/${c.slug}`} className="hover:text-secondary-light">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">Industries</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {industries.slice(0, 5).map((i) => (
                <li key={i.slug}>
                  <Link to="/industries" className="hover:text-secondary-light">
                    {i.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-white">Company</h3>
            <ul className="mt-4 space-y-3 text-sm">
              {companyLinks.map((l) => (
                <li key={l.name}>
                  <Link to={l.to} className="hover:text-secondary-light">
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 grid gap-6 border-t border-white/10 pt-8 text-sm sm:grid-cols-3">
          <div className="flex gap-3">
            <Icon name="pin" className="h-5 w-5 flex-none text-secondary-light" />
            <span className="text-white/60">
              {company.address.line1}, {company.address.line2}, {company.address.line3}
            </span>
          </div>
          <div className="flex gap-3">
            <Icon name="mail" className="h-5 w-5 flex-none text-secondary-light" />
            <a href={`mailto:${company.email}`} className="text-white/60 hover:text-white">
              {company.email}
            </a>
          </div>
          <div className="flex gap-3">
            <Icon name="phone" className="h-5 w-5 flex-none text-secondary-light" />
            <span className="text-white/60">{company.phones.join(' · ')}</span>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6 text-center text-xs text-white/40">
          &copy; {new Date().getFullYear()} {company.legalName}. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
